//
//
//
//
//

export default {
  name: "AppMain",
  computed: {
    cachedViews: function cachedViews() {
      console.log(JSON.stringify(this.$store.state.tagsView.cachedViews), "cachedViews");
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};